import { helper as buildHelper } from '@ember/component/helper';
export default buildHelper(function (value, options) {
  if (value[0]) {
    return value[0].toString().replace(options.replace, options.replaceWith);
  }

  return '';
});
